import classes from './CategoryTemplate.module.scss'
import { CategoryType, ICategoryType } from '../../../../../../enums/CetificateFileCategoryType'
import { Dropdown } from 'primereact/dropdown'
import { IAttachmentBulkFileObject } from '../AddAttachmentsBulkV2'
import { CertificateDocumentTypeV2 } from '../../../../../../enums/CertificateDocumentType'
import { useDispatch } from 'react-redux'
import { updateAttachmentList } from '../../../../../../features/createCertificate/createCertificateSlice'
interface CategoryTemplateProps {
  activeDocumentType: CertificateDocumentTypeV2
  rowData: IAttachmentBulkFileObject
  categoryList: Array<ICategoryType>
  refreshTable: () => void
  uploadFileList: Array<any>
}

const CategoryTemplate = (props: CategoryTemplateProps) => {
  const { activeDocumentType, rowData, categoryList, refreshTable, uploadFileList } = props
  const dispatch = useDispatch()

  const onCategoryChange = (e: { value: any }) => {
    let value = CategoryType.None
    if (e.value != undefined) value = e.value

    dispatch(
      updateAttachmentList([
        {
          tempUniqueId: rowData.tempUniqueId,
          newValue: value,
          group_index: props.activeDocumentType,
        },
      ])
    )
  }

  return (
    <>
      <Dropdown
        value={rowData?.category}
        options={categoryList}
        onChange={onCategoryChange}
        optionLabel="name"
        optionValue="value"
        className={classes['custom-dropdown']}
        style={{ fontSize: '10px', width: '100%' }}
        optionDisabled="disabled"
        placeholder="Select"
        showClear={
          rowData.group_index !== CertificateDocumentTypeV2.TestReport &&
          rowData?.category != CategoryType.None
        }
      />
    </>
  )
}

export default CategoryTemplate
